import type { FC } from "react";
import React from "react";

import { Dropdown } from "../../../Dropdown";
import { Search as SearchMenuBase } from "../../../Dropdown/components/Menu/components/Search/MenuSearch";
import { createDisplayNameForDropdownElement } from "../../../Dropdown/utils/getDisplayName";

import type { MenuProps } from "../../../Dropdown";

import classes from "./SearchMenu.styl";

export const SearchMenu: FC<MenuProps> = ({
    children,
    "data-tsid": tsid,
    ...props
}) => {
    return (
        <Dropdown.Menu
            as={SearchMenuBase}
            alignment="center"
            className={classes["search-menu"]}
            {...props}
            data-tsid={tsid}
            data-uikit=""
        >
            {children}
        </Dropdown.Menu>
    );
};

SearchMenu.displayName = createDisplayNameForDropdownElement("Menu");
